
export default function (data:any):any {
	console.log("----", data);
	return {
		discount: data.discount,
		discount_model: data.discount_model,
		discount_type: data.discount_type,
		id: data.id,
		max_price_total: data.max_price_total,
		min_price_total: data.min_price_total,
		name: data.name,
		price: data.price,
		price_model: data.price_model,
		rule_config: data.rule_config,
		rules: data.price_model.value === "FIXED" ? [] : data.rules,
		rulesList: data.price_model.value === "FIXED" ? [] : data.rulesList,

		subsequentValue: (data.price_model.value === "FIXED" || !data.price_rule) ? "" : data.subsequentValue,
		price_rule: data.price_model.value === "FIXED" ? null : data.price_rule,

		label: data.name,
		value: data.id,

		new : data.new,


	}
}